var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-purple" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-tabs",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingAssignedApplications,
                  expression: "loadingAssignedApplications"
                }
              ],
              attrs: { type: "border-card", stretch: "" },
              on: { "tab-click": _vm.handleClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { name: "fromProponent" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Από εισηγητή "),
                    _c("span", { staticClass: "todo-badge" }, [
                      _vm._v(" " + _vm._s(_vm.fromProponentNewLength))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "done-badge" }, [
                      _vm._v(" " + _vm._s(_vm.fromProponentFinalLength))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      ref: "singleTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        stripe: "",
                        border: "",
                        "highlight-current-row": "",
                        data: _vm.loadAssignedAppsProponent
                      },
                      on: { "row-click": _vm.loadApp }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          index: _vm.indexMethod,
                          width: "30"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "surname", label: "Επώνυμο" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "name", label: "Όνομα" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "academicAreaTitle",
                          label: "Ακαδημαϊκή περιοχή"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "Ημ/νια Ολοκλήρωσης Προελέγχου",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.dateCompleted.substring(0, 10)
                                    )
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "right",
                          label: "Κατάσταση",
                          align: "center",
                          width: "100"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.finalizedByUser
                                  ? _c("span", { staticClass: "done-btn" }, [
                                      _c("i", { staticClass: "el-icon-check" })
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !scope.row.finalizedByUser
                                  ? _c("span", { staticClass: "todo-btn" }, [
                                      _c("i", { staticClass: "el-icon-edit" })
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { name: "fromPresident" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Από Πρόεδρο "),
                    _c("span", { staticClass: "todo-badge" }, [
                      _vm._v(" " + _vm._s(_vm.fromPresidentNewLength))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "done-badge" }, [
                      _vm._v(" " + _vm._s(_vm.fromPresidentFinalLength))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      ref: "singleTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        stripe: "",
                        border: "",
                        "highlight-current-row": "",
                        data: _vm.loadAssignedAppsPresident
                      },
                      on: { "row-click": _vm.loadApp }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          index: _vm.indexMethod,
                          width: "30"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "surname", label: "Επώνυμο" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "name", label: "Όνομα" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "academicAreaTitle",
                          label: "Ακαδημαϊκή περιοχή"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "Ημ/νια Ολοκλήρωσης Προελέγχου",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(scope.row.updatedAt.substring(0, 10))
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "right",
                          label: "Κατάσταση",
                          align: "center",
                          width: "100"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.finalizedByUser
                                  ? _c("span", { staticClass: "done-btn" }, [
                                      _c("i", { staticClass: "el-icon-check" })
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !scope.row.finalizedByUser
                                  ? _c("span", { staticClass: "todo-btn" }, [
                                      _c("i", { staticClass: "el-icon-edit" })
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { name: "fromConsultant" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Από Ακαδ. Σύμβουλο "),
                    _c("span", { staticClass: "todo-badge" }, [
                      _vm._v(" " + _vm._s(_vm.fromConsultantNewLength))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "done-badge" }, [
                      _vm._v(" " + _vm._s(_vm.fromConsultantFinalLength))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      ref: "singleTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        stripe: "",
                        border: "",
                        "highlight-current-row": "",
                        data: _vm.loadAssignedAppsConsultant
                      },
                      on: { "row-click": _vm.loadApp }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          index: _vm.indexMethod,
                          width: "30"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "surname", label: "Επώνυμο" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "name", label: "Όνομα" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "academicAreaTitle",
                          label: "Ακαδημαϊκή περιοχή"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "Ημ/νια Ολοκλήρωσης Προελέγχου",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(scope.row.updatedAt.substring(0, 10))
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "right",
                          label: "Κατάσταση",
                          align: "center",
                          width: "100"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.finalizedByUser
                                  ? _c("span", { staticClass: "done-btn" }, [
                                      _c("i", { staticClass: "el-icon-check" })
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !scope.row.finalizedByUser
                                  ? _c("span", { staticClass: "todo-btn" }, [
                                      _c("i", { staticClass: "el-icon-edit" })
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { name: "fromVice" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _vm._v("Από Αντιπρόεδρο "),
                    _c("span", { staticClass: "todo-badge" }, [
                      _vm._v(" " + _vm._s(_vm.fromViceNewLength))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "done-badge" }, [
                      _vm._v(" " + _vm._s(_vm.fromViceFinalLength))
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      ref: "singleTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        stripe: "",
                        border: "",
                        "highlight-current-row": "",
                        data: _vm.loadAssignedAppsVice
                      },
                      on: { "row-click": _vm.loadApp }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          index: _vm.indexMethod,
                          width: "30"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "surname", label: "Επώνυμο" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "name", label: "Όνομα" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "academicAreaTitle",
                          label: "Ακαδημαϊκή περιοχή",
                          width: "170"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "applicationType",
                          label: "Είδος αίτησης",
                          width: "130"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "Ανάθεση",
                          width: "95",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(scope.row.updatedAt.substring(0, 10))
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          fixed: "right",
                          label: "Κατάσταση",
                          align: "center",
                          width: "100"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.finalizedByUser
                                  ? _c("span", { staticClass: "done-btn" }, [
                                      _c("i", { staticClass: "el-icon-check" })
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                !scope.row.finalizedByUser
                                  ? _c("span", { staticClass: "todo-btn" }, [
                                      _c("i", { staticClass: "el-icon-edit" })
                                    ])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loadingWorkingApplication,
              expression: "loadingWorkingApplication"
            }
          ],
          staticStyle: { "background-color": "transparent" },
          attrs: {
            visible: _vm.dialogViewComp,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": true,
            center: true
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogViewComp = $event
            }
          }
        },
        [
          _c("el-card", { staticClass: "box-card bg-purple" }, [
            _c(
              "div",
              { attrs: { slot: "header" }, slot: "header" },
              [_c("UserAppInfo")],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text item" },
              [
                _c(
                  "el-tabs",
                  {
                    on: { "tab-click": _vm.handleClick },
                    model: {
                      value: _vm.activeName,
                      callback: function($$v) {
                        _vm.activeName = $$v
                      },
                      expression: "activeName"
                    }
                  },
                  [
                    [
                      _vm.showWorkingApplication
                        ? _c("executive-board-member-judgement", {
                            on: { closeDialogEvent: _vm.closeDialogEvent }
                          })
                        : _vm._e()
                    ]
                  ],
                  2
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe205cd0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe205cd0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ExecutiveBoardMemberApplicationsLane.vue
// module id = null
// module chunks = 